export default __webpack_public_path__ + "static/media/emaOrder.049a58cb.JPG";